import { CHARTS_COLORS } from '@scope/scope-one-ui/theme';
import { GroupType } from '../types/esgSentiment';

export const groupColors: Record<GroupType, string> = {
  company: CHARTS_COLORS[0],
  peers: CHARTS_COLORS[1],
  industry: CHARTS_COLORS[2],
  sector: CHARTS_COLORS[3],
  custom: CHARTS_COLORS[4],
};
